var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "c-mobile-nav-close t-heading-5 j-mobile-nav__close",
      attrs: { type: "button", tabindex: "2" },
      on: { click: _vm.emitClick }
    },
    [
      _c("img", {
        attrs: {
          src: require("../../assets/icons/nav-close.svg"),
          alt: "close"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }